import Image from 'next/image';
import React from 'react';
import { AuthorBlogCardProps } from '../../types/pages/author';
import Link from 'next/link';
import { useRouter } from 'next/router';

export const AuthorBlogCard = ({
  blog,
  authorName,
  authorImage
}: AuthorBlogCardProps) => {
  const router = useRouter();

  const isBlogPage = router.route === '/blog/[slug]' ? true : false;
  return (
    <Link target="_blank" href={`/blog/${blog.slug}`}>
      <div className="border border-[#E0E0E0] rounded-lg flex-shrink-0">
        <div className="flex-col flex xl:flex-row xl:gap-[22px] 2xl:gap-[26px]">
          <Image
            src={blog?.image?.url ?? blog.image}
            alt={blog?.image?.alternativeText ?? blog.name}
            width={210}
            height={190}
            className={`object-cover w-[100%] h-[180px] lg:h-[210px] xl:w-[210px] ${
              isBlogPage ? `xl:h-[170px]` : `xl:h-[195px]`
            }  rounded-tl-lg rounded-tr-lg xl:rounded-lg`}
          />

          <div className="py-5 px-4 xl:pt-[14px] xl:pb-[8px] xl:pr-[26px] xl:px-0 xl:w-[60%]">
            <h3
              className={`text-black13 text-base font-semibold ${
                !isBlogPage && `mb-[10px]`
              } overflow-hidden`}
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical'
              }}
            >
              {blog?.name?.includes('-') &&
              blog?.name?.split('-')?.pop()?.trim() === 'See Sight Tours'
                ? blog.name.split('-').slice(0, -1).join('-').trim()
                : blog.name}
            </h3>
            <div className="flex flex-row items-center mb-3">
              {!isBlogPage && (
                <div className="flex gap-1.5 items-center">
                  <Image
                    src={'/gray-calendar-icon.svg'}
                    alt="calender-icon"
                    width={10}
                    height={12}
                  />
                  <p className="text-xs text-gray75 whitespace-nowrap mt-[1px]">
                    {blog.publication_date}
                  </p>
                </div>
              )}

              {/* <SeparatorLine className="mx-2.5" /> */}
              {/* <div className="flex gap-1.5 items-center">
                <Image
                  src={'/gray-clock-icon.svg'}
                  alt="clock-icon"
                  width={12}
                  height={12}
                />
                <p className="text-xs text-gray75 whitespace-nowrap mt-[1px]">
                  {'10'} Min. To Read
                </p>
              </div> */}
            </div>
            <p
              className="leading-normal text-sm text-gray75 mb-[18px] overflow-hidden h-[63px]"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical'
              }}
            >
              {blog.snippet}
            </p>
            {authorName && (
              <Link
                className="flex gap-1.5 items-center"
                href={isBlogPage ? `/author/${blog.authorSlug}` : router.asPath}
              >
                <Image
                  src={authorImage ?? '/default-profile-icon.svg'}
                  alt="author-pic"
                  width={50}
                  height={50}
                  className="rounded-full w-[25px] h-[25px]"
                />
                <p
                  className={`text-xs text-gray75 ${
                    isBlogPage && ` hover:underline hover:text-darkBlue`
                  } whitespace-nowrap`}
                >
                  {authorName}
                </p>
              </Link>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
